module.exports = __webpack_public_path__ + "static/media/AriesFinance.bd9b0070.png";